import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.6663 6.66699V4.00033C14.6663 3.26699 14.0663 2.66699 13.333 2.66699H2.66634C1.93301 2.66699 1.33967 3.26699 1.33967 4.00033V6.66699C2.07301 6.66699 2.66634 7.26699 2.66634 8.00033C2.66634 8.73366 2.07301 9.33366 1.33301 9.33366V12.0003C1.33301 12.7337 1.93301 13.3337 2.66634 13.3337H13.333C14.0663 13.3337 14.6663 12.7337 14.6663 12.0003V9.33366C13.933 9.33366 13.333 8.73366 13.333 8.00033C13.333 7.26699 13.933 6.66699 14.6663 6.66699ZM13.333 5.69366C12.5397 6.15366 11.9997 7.02033 11.9997 8.00033C11.9997 8.98033 12.5397 9.84699 13.333 10.307V12.0003H2.66634V10.307C3.45967 9.84699 3.99967 8.98033 3.99967 8.00033C3.99967 7.01366 3.46634 6.15366 2.67301 5.69366L2.66634 4.00033H13.333V5.69366ZM6.04634 10.667L7.99967 9.41366L9.95301 10.667L9.35967 8.42699L11.153 6.96032L8.83967 6.82032L7.99967 4.66699L7.15301 6.81366L4.83967 6.95366L6.63301 8.42033L6.04634 10.667Z",
            fill: "#E2E1E5"
        })
    }));
};
export default Icon;
